import { defineStore } from 'pinia'
import { ref } from 'vue'

export default defineStore('invasiveServiceInfoStore', () => {
  const isCreatedComponent = ref(false)
  const isOpenedReferralForServiceModal = ref(false)
  const isOpenedPreliminaryConsultationModal = ref(false)

  const allowTreatmentReferral = ref(false)
  const requiresPrimaryConsultation = ref(false)
  const hasPrimaryConsultationDoctors = ref(false)
  const handleAppointment = ref<() => void>(() => {})
  const handleConfirmReferral = ref<() => void>(() => {})
  const doctorSpecialities = ref<Array<{
    name: string
    url: string
  }>>([])
  const filterDate = ref<string>()

  function reset() {
    allowTreatmentReferral.value = false
    requiresPrimaryConsultation.value = false
    handleConfirmReferral.value = () => {}
    handleAppointment.value = () => {}
    doctorSpecialities.value = []
    filterDate.value = undefined
  }

  function getDoctorSpecialities({
    specialities,
    date,
    townTranslit,
  }: {
    specialities: Array<{
      name: string
      translit: string
    }>
    date?: string
    townTranslit: string
  }) {
    if (!specialities || !townTranslit) {
      return []
    }

    const dateFilterQuery = date
      ? `?date_from=${date}&date_to=${date}`
      : ''

    if (
      !window.LANGUAGE_DATA
      || !window.LANGUAGE_DATA.needTranslate
      || window.LANGUAGE_DATA.currentLanguage.iso === window.LANGUAGE_DATA.defaultLanguageIso
    ) {
      return specialities.map(i => ({
        name: i.name,
        url: `/${townTranslit}/${i.translit}/${dateFilterQuery}`,
      }))
    }

    return specialities.map(i => ({
      name: i.name,
      url: `${window.LANGUAGE_DATA.currentLanguage.iso}/${townTranslit}/${i.translit}/${dateFilterQuery}`,
    }))
  }

  function openInfoModal(payload: {
    allowTreatmentReferral: boolean
    requiresPrimaryConsultation: boolean
    hasPrimaryConsultationDoctors: boolean
    handleConfirmReferral: () => void
    handleAppointment?: () => void
    doctorSpecialities?: Array<{
      name: string
      translit: string
    }>
    date?: string
    townTranslit?: string
  }) {
    reset()

    allowTreatmentReferral.value = payload.allowTreatmentReferral
    requiresPrimaryConsultation.value = payload.requiresPrimaryConsultation
    hasPrimaryConsultationDoctors.value = payload.hasPrimaryConsultationDoctors
    handleConfirmReferral.value = payload.handleConfirmReferral
    handleAppointment.value = payload.handleAppointment || (() => {})

    if (payload.doctorSpecialities && payload.townTranslit) {
      doctorSpecialities.value = getDoctorSpecialities({
        specialities: payload.doctorSpecialities,
        date: payload.date,
        townTranslit: payload.townTranslit,
      })
    } else {
      doctorSpecialities.value = []
    }

    if (allowTreatmentReferral.value) {
      isOpenedReferralForServiceModal.value = true
    } else {
      isOpenedPreliminaryConsultationModal.value = true
    }
  }

  return {
    isCreatedComponent,
    isOpenedReferralForServiceModal,
    isOpenedPreliminaryConsultationModal,
    allowTreatmentReferral,
    requiresPrimaryConsultation,
    handleAppointment,
    handleConfirmReferral,
    doctorSpecialities,
    hasPrimaryConsultationDoctors,
    filterDate,
    openInfoModal,
  }
})
